import templateUrl from 'emun.vendor/vendorgroup-dashboard.htm'
import controller from 'emun.vendor/vendorgroup-dashboard.controller'


let VendorGroupDashboard = {
    bindings: {
        groupId: '@'
    },
    require:{
        container: '^vendorgroupContainer'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default VendorGroupDashboard